import React from 'react';
import { Form, Input, Button, Modal, TreeSelect } from 'antd';
import _ from 'lodash';
import API from '@/api'

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  labelAlign: 'left'
};

class CategoryModel extends React.Component {
  constructor (props) {
    super(props)

    this.formRef = React.createRef()

    this.state = {
      visibleCategory: false,
      value: undefined,
    }
  }

  onChange = value => {
    this.setState({ value });
  };

  addCategory () {
    this.showModalCategory()
  }

  showModalCategory = () => {
    this.setState({
      visibleCategory: true,
    });
  };

  async vaild () {
    const values = await this.formRef.current.validateFields().catch(console.log)
    return values
  }

  handleCancelCategory = async e => {
    await this.clear()
    this.setState({
      visibleCategory: false,
    });
  };

  handleOkCategory = async e => {
    const rre = await this.vaild()
    if (!rre) return

    const data = _.pick(rre, ['id', 'title', 'category_id'])
    data.category_id = data.category_id || undefined
    const res = await API.SaveCategory(data)
    if (res.code !== 200) return

    if (!rre) return

    this.clear()
    
    this.setState({
      visibleCategory: false,
    });

    await API.GetCategory()
    this.props.refreshTree()
  };

  clear () {
    this.formRef.current.resetFields();
  }

  edit = (item) => {
    this.formRef.current.setFieldsValue(item);
  }

  async componentDidMount () {
  }

  fun (list) {
    const newList = []
    for (let i = 0; i < list.length; i++) {
      const item = list[i]
      newList[i] = {
        title: item.title,
        value: item.id,
        children: item.child && item.child.length ? this.fun(item.child) : []
      }
    }
    return newList
  }

  get treeDom () {
    const treeData = [ ...this.props.data ]
    if (!treeData.length) return []
    const rt = this.fun(treeData)
    return rt
  }

  render () {
    const { treeDom, state } = this
    return (
      <div>
        <Button
          type="primary"
          style={{ width: '100%' }}
          onClick={() => this.addCategory()}
        >新增分类</Button>
        <Modal
          title="Basic Modal"
          visible={this.state.visibleCategory}
          onOk={this.handleOkCategory}
          onCancel={this.handleCancelCategory}
          width={400}
        >
          <Form
            ref={this.formRef}
            {...layout}
            name="basic"
            initialValues={{ remember: true }}
          >
            <Form.Item
              label="CategoryId"
              name="category_id"
              rules={[{ required: false }]}
            >
              <TreeSelect
                style={{ width: '100%' }}
                value={this.state.value}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                treeData={treeDom}
                placeholder="Please select"
                treeDefaultExpandAll
                onChange={this.onChange}
              />
            </Form.Item>

            <Form.Item
              hidden={true}
              label="Id"
              name="id"
              rules={[{ required: false }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: 'Please input your title!' }]}
            >
              <Input />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default CategoryModel;
